import _ from "lodash"
import moment from "moment"
import Vue from "vue"

export const setStockAuto = (products, fulfilled) => {
  var isStockCompany = Vue.prototype.$branch.isStockCompany
  products.map((product) => {
    ;[product].concat(product.isBundle ? product.children : []).forEach((p) => {
      p.availableStocks.forEach((i) => {
        if (!i.batchName) {
          i.batchName = "-"
        }
      })
      p.stocks = p.availableStocks.mergeTotal("stockId", "availableQty")

      var bs = _.orderBy(
        p.availableStocks,
        [
          "isDefaultTmp",
          "expiryDateTmp",
          "manufacturingDateTmp",
          "inventoryDateTmp",
        ],
        ["desc", "asc", "asc", "asc"],
      )

      p.batchNames = bs

      p.fulfills = []
      p.remain = product.remain * (p.bundleQuantity || 1)
      if (fulfilled && fulfilled.length) {
        fulfilled
          .filter(
            (i) =>
              i.productId == p.productId &&
              i.bundleId == p.bundleId &&
              i.isGift == p.isGift,
          )
          .map((f) => {
            var oldS = p.fulfills.find((i) => i.stockId == f.stockId)
            if (oldS) {
              oldS.batchNames.push({
                quantity: f.quantity,
                batchName: f.batchName,
              })
            } else {
              var bs = p.batchNames.filter((i) => i.stockId == f.stockId)
              p.fulfills.push({
                stockId: f.stockId,
                allBatchNames: bs,
                batchNames: [
                  {
                    quantity: f.quantity,
                    batchName: f.batchName == null ? "-" : f.batchName,
                  },
                ],
              })
            }
          })
      } else {
        p.remain = product.remain * (p.bundleQuantity || 1)
        var remain = p.remain
        p.fulfills = []
        bs.filter((a) => !a.isNotForSell).forEach((b) => {
          if (remain <= 0) {
            return
          }
          var stock = p.fulfills.find((i) => i.stockId == b.stockId)
          var q = Math.min(remain, b.availableQty)

          remain = remain - q
          if (q > 0) {
            if (stock) {
              stock.batchNames.push({
                quantity: q,
                batchName: b.batchName,
              })
            } else {
              p.fulfills.push({
                stockId: b.stockId,
                allBatchNames: bs.filter((i) => i.stockId == b.stockId),
                batchNames: [
                  {
                    quantity: q,
                    batchName: b.batchName,
                  },
                ],
              })
            }
          }
        })
        if (remain > 0 && (p.saleOver || !isStockCompany)) {
          if (p.fulfills[0]) {
            p.fulfills[0].batchNames[0].quantity += remain
          } else {
            var s = bs[0] || {}
            p.fulfills = [
              {
                stockId: s.stockId,
                allBatchNames: bs.filter((i) => i.stockId == s.stockId),
                batchNames: [
                  {
                    quantity: remain,
                    batchName: s.batchName,
                  },
                ],
              },
            ]
          }
          remain = 0
        }
      }

      if (p.fulfills.length == 0) {
        p.fulfills = [
          {
            stockId: "",
            allBatchNames: [],
            batchNames: [
              {
                quantity: 0,
                batchName: "-",
              },
            ],
          },
        ]
      }
      p.quantityInput = product.remain * (p.bundleQuantity || 1)
      p.fulfills.forEach((i) => {
        i.quantity = i.batchNames.reduce((a, b) => a + +b.quantity, 0)
      })
      p.totalFF = p.fulfills.reduce((a, b) => a + +b.quantity, 0)
      p.availableQty = p.availableStocks.reduce(
        (a, b) => a + +b.availableQty,
        0,
      )

      if (
        p.remain > p.availableQty &&
        !p.isBundle &&
        !p.noCheckWarehouse &&
        !p.saleOver &&
        isStockCompany
      ) {
        p.missStock = true
      }
      if (
        p.availableQty == 0 &&
        // p.totalFF == 0 &&
        !p.isBundle &&
        !p.noCheckWarehouse &&
        !p.saleOver &&
        isStockCompany
      ) {
        p.outOfStock = true
      }
    })
  })
  return products
}
export const toJsonOrder = (order) => {
  const round = Vue.prototype.$round
  const d = {
    quoteId: order.quoteId || undefined,
    invoiceId: order.invoiceId || order.id || undefined,
    // invoiceDate: order.orderDate || undefined,
    grandTotalBeforeTax: round(order.grandTotalBeforeTax || 0),
    grandTotal: round(order.grandTotal || 0),
    remainPayment: round(order.remainPayment || 0),
    totalSurcharge: round(order.totalSurcharge || 0),
    surcharge: round(order.surcharge || 0),
    employeeSales: (order.employeeSales || []).map((i) => ({
      id: i.id || undefined,
      isDelete: i.isDelete || false,
      employeeId: i.employeeId || undefined,
      percentSale: round(i.percentSale || 0),
      moneySale: round(i.moneySale || 0),
    })),
    invoiceProcessSteps: (order.invoiceProcessSteps || []).map((process) => ({
      id: process.id || undefined,
      code: process.code || undefined,
      shippingReq: process.shippingReq
        ? {
            id: process.id ? process.shippingReq.id : undefined,
            cusName: process.shippingReq.cusName,
            cusPhone: process.shippingReq.cusPhone,
            cusCity: process.shippingReq.cusCity,
            cusDistrict: process.shippingReq.cusDistrict,
            cusWard: process.shippingReq.cusWard,
            cusAddress: process.shippingReq.cusAddress,
            description: process.shippingReq.description,
            type: process.shippingReq.type,
            cusCountry: process.shippingReq.cusCountry,
            newAddress: process.shippingReq.cusNewAddress,
            newWard: process.shippingReq.cusNewWard,
            newCity: process.shippingReq.cusNewCity,
          }
        : undefined,
      isProcessReturn: process.isProcessReturn || false,
      stepName: process.stepName || "",
      processStatus: process.processStatus,
      description: process.description || "",
      subStatus: process.subStatus || "",
      surcharges: (process.surcharges || []).map((surcharge) => ({
        id: process.id ? surcharge.id : undefined,
        surchargeType: surcharge.surchargeType || "",
        amount: round(surcharge.amount || 0),
        description: surcharge.description || "",
        isDelete: surcharge.isDelete || false,
        packingId: surcharge.packingId || undefined,
      })),
      stepInitsReqs: process.products.map((i) => ({
        id: process.id ? i.id : undefined,
        productId: i.productId,
        productQuantity: i.productQuantity || i.quantity,
        isGift: i.isGift || false,
        isDelete: i.isDelete || false,
      })),
      total: round(process.total || 0),
      costTotal: round(process.costTotal || 0),
      beforeSaleOffTotal: round(process.beforeSaleOffTotal || 0),
      saleOffTotal: round(process.saleOffTotal || 0),
      cashDiscount: round(process.cashDiscount || 0),
      voucherDiscount: round(process.voucherDiscount || 0),
      couponDiscount: round(process.couponDiscount || 0),
      moneyPointConvert: round(process.moneyPointConvert || 0),
      membershipDiscountMoney: round(process.membershipDiscountMoney || 0),
      grandTotalBeforeTax: round(process.grandTotalBeforeTax || 0),
      taxMoney: round(process.taxMoney || 0),
      grandTotal: round(process.grandTotal || 0),
      surchargeProductTotal: round(process.surchargeProductTotal || 0),
      surcharge: round(process.surcharge || 0),
      discountCustomerTotal: round(process.discountCustomerTotal || 0),
      doneStock: process.doneStock || false,
      isDebt: process.isDebt || false,
      customFieldValues: (process.customFieldValues || []).map((i) => ({
        id: i.id || undefined,
        fieldCode: i.fieldCode || "",
        value: i.value || i.stringValue,
      })),
      invoiceDetails: (process.invoiceDetails || [])
        .filter((a) => !a.id) // only for stock shipping
        .map((i) => {
          return {
            bundleId: i.bundleId,
            productId: i.productId,
            productQuantity: i.productQuantity || 0,
            productPrice: round(i.productPrice || 0),
            costPrice: i.costPrice || 0,
            total: round(i.total || 0),
            costTotal: i.costTotal || 0,
            cashSaleOff: round(i.cashSaleOff || 0),
            surcharge: round(i.surcharge || 0),
            totalPayment: round(i.totalPayment || 0),
            upc: i.upc || undefined,
            isBundle: i.isBundle || false,
            surchargeValue: round(i.surchargeValue || 0),
            surchargeType: i.surchargeType,
            saleOffType: i.saleOffType,
            saleOffValue: round(i.saleOffValue || 0),
            isGift: i.isGift || false,
            discountCustomerPercent: i.discountCustomerPercent || 0,
            discountCustomer: round(i.discountCustomer || 0),
            levelId: i.levelId,
            stocks: i.stocks,
            taxMoney: round(i.taxMoney || 0),
            percentTax: round(i.percentTax || 0),
            totalAfterTax: round(i.totalAfterTax || 0),
            totalBeforeTax: round(i.totalBeforeTax || 0),
            orderSurcharge: round(i.orderSurcharge || 0),
            orderSaleOff: round(i.orderSaleOff || 0),
            transferUnit: i.transferUnit || undefined,
          }
        }),
    })),
    surcharges: (order.surcharges || []).map((surcharge) => ({
      id: surcharge.id || undefined,
      surchargeType: surcharge.surchargeType || "",
      amount: round(surcharge.amount || 0),
      description: surcharge.description || "",
      isDelete: surcharge.isDelete || false,
      packingId: surcharge.packingId || undefined,
    })),
    invoiceInitialReqs: (order.invoiceInitials || []).map((item) => ({
      id: item.id,
      productId: item.productId,
      productQuantity: item.productQuantity || 0,
      productPrice: round(item.productPrice || 0),
      costPrice: item.costPrice || 0,
      total: round(item.total || 0),
      costTotal: item.costTotal || 0,
      cashSaleOff: round(item.cashSaleOff || 0),
      totalPayment: round(item.totalPayment || 0),
      isBundle: item.isBundle,
      bundleId: item.bundleId,
      isDelete: item.isDelete || false,
      surcharge: round(item.surcharge || 0),
      surchargeValue: round(item.surchargeValue || 0),
      surchargeType: item.surchargeType,
      saleOffType: item.saleOffType,
      saleOffValue: round(item.saleOffValue || 0),
      isGift: item.isGift || false,
      isCost: item.isCost || false,
      percentTax: item.percentTax || 0,
      taxMoney: round(item.taxMoney || 0),
      discountCustomerPercent: round(item.discountCustomerPercent || 0),
      discountCustomer: round(item.discountCustomer || 0),
      totalAfterTax: round(item.totalAfterTax || 0),
      totalBeforeTax: round(item.totalBeforeTax || 0),
      orderSurcharge: round(item.orderSurcharge || 0),
      orderSaleOff: round(item.orderSaleOff || 0),
      transferUnit: item.transferUnit || undefined,
      groupName: item.groupName || undefined,
    })),
    invoiceDetailReqs: [],
    priceLevelId:
      order.priceLevelId || Vue.prototype.$priceLevelId || undefined,
    costTotal: round(order.costTotal || 0),
    saleOffTotal: round(order.saleOffTotal || 0),
    total: round(order.total || 0),
    beforeSaleOffTotal: round(order.beforeSaleOffTotal || 0),
    discountCustomerTotal: round(order.discountCustomerTotal || 0),
    taxMoney: round(order.taxMoney || 0),
    surchargeProductTotal: round(order.surchargeProductTotal || 0),
    voucherDiscount: round(order.voucherDiscount || 0),
    cashDiscount: round(order.cashDiscount || 0),
    couponDiscount: round(order.couponDiscount || 0),
    membershipDiscountMoney: round(order.membershipDiscountMoney || 0),
    totalDiscount: round(order.totalDiscount || 0),
    paidMoney: round(order.paidMoney || 0),
    totalDebt: round(order.totalDebt || 0),
    remainDebt: round(order.remainDebt || 0),
    stockStatus: order.stockStatus || "UNFINISHED",
    paymentStatus: order.paymentStatus || "UNPAID",
    description: order.description || "",
    exchangeRate: order.exchangeRate || 1,
    currency: order.currency || "VND",
    channel: order.channel || "",
    isGetPointMember: order.isGetPointMember || false,
    cartId: order.cartId || undefined,
    customerId: order.customerId || undefined,
    status: order.status || "UNFINISHED",
    invoiceDiscounts: (order.invoiceDiscounts || []).map((i) => ({
      id: i.id,
      discountForm: i.discountForm,
      discountCode: i.discountCode,
      discountType: i.discountType,
      discountValue: i.discountValue,
      discountMoney: i.discountMoney,
      isDelete: i.isDelete,
    })),
    employeeSalesProcess: (order.employeeSalesProcess || []).map((i) => ({
      employeeId: i.employeeId,
      processId: i.processId,
      money: round(i.money || 0),
      isDelete: i.isDelete,
    })),
    isOnline: order.isOnline || false,
    cashDiscountPercent: round(order.cashDiscountPercent || 0),
    numberPointConvert: round(order.numberPointConvert || 0),
    moneyPointConvert: round(order.moneyPointConvert || 0),
    membershipDiscountPercent: round(order.membershipDiscountPercent || 0),
    title: order.title || "",
    percentTax: order.percentTax || 0,
    isB2B: order.isB2B || false,
    subStatus: order.subStatus || "",
    invoiceCashPayments: (order.invoiceCashPayments || [])
      .map((i) => ({
        id: i.id || undefined,
        totalPayment: round(i.totalPayment || 0),
        currencyUnit: i.currencyUnit,
        totalCash: i.totalCash,
        exchangePrice: i.exchangePrice,
        paymentTime: i.paymentTime,
      }))
      .filter((a) => !a.id),
    invoiceCardPayments: (order.invoiceCardPayments || [])
      .map((i) => ({
        id: i.id || undefined,
        cardType: i.cardType,
        cardNumber: i.cardNumber,
        totalPayment: i.totalPayment,
        isExtra: i.isExtra,
        description: i.description,
        paymentStatus: i.paymentStatus,
        paymentTime: i.paymentTime,
        currencyUnit: i.currencyUnit,
        totalMoney: i.totalMoney,
        exchangePrice: i.exchangePrice,
      }))
      .filter((a) => !a.id),
    cashTotal: round(order.cashTotal || 0),
    cardTotal: round(order.cardTotal || 0),
    cashDiscountType: order.cashDiscountType || "MONEY",
    orderType: order.orderType || "DEBT",
    personInChargeId: order.personInChargeId || undefined,
    extraMoney: round(order.extraMoney || 0),
    locationId: order.locationId || undefined,
    locationName: order.locationName || "",
    areaId: order.areaId || undefined,
    areaName: order.areaName || "",
    bulkId: order.bulkId || undefined,
    shippingReq: order.shippingReq
      ? {
          id: order.shippingReq.id || undefined,
          cusName: order.shippingReq.cusName,
          cusPhone: order.shippingReq.cusPhone,
          cusCity: order.shippingReq.cusCity,
          cusDistrict: order.shippingReq.cusDistrict,
          cusWard: order.shippingReq.cusWard,
          cusAddress: order.shippingReq.cusAddress,
          description: order.shippingReq.description,
          type: order.shippingReq.type,
          cusCountry: order.shippingReq.cusCountry,
          newAddress: order.shippingReq.cusNewAddress,
          newWard: order.shippingReq.cusNewWard,
          newCity: order.shippingReq.cusNewCity,
        }
      : undefined,
    contractId: order.contractId || undefined,
    campaignId: order.campaignId || undefined,
    customFieldValues: (order.customFieldValues || []).map((i) => ({
      id: i.id || undefined,
      fieldCode: i.fieldCode || "",
      value: i.value || i.stringValue,
    })),
    baseAmount: round(order.baseAmount || 0),
    orderStatus: order.orderStatus || "UNFINISHED",
    branchId: order.branchId || Vue.prototype.$branchId,
    branchName: order.branchName || Vue.prototype.$branch.branchName,
    companyId: order.companyId || Vue.prototype.$companyId,
    companyName: order.companyName || Vue.prototype.$company.companyName,
  }
  if (!d.invoiceId) {
    return {
      ...d,
      invoiceDetailReqs: undefined,
      status: undefined,
    }
  }
  return {
    ...d,
    status: order.status || order.orderStatus,
    orderStatus: undefined,
    branchId: undefined,
    branchName: undefined,
    companyId: undefined,
    companyName: undefined,
  }
}
export const countPriceB2B = (order) => {
  const round = Vue.prototype.$round
  let total = 0
  order.totalQuantity = 0
  order.beforeSaleOffTotal = 0
  order.saleOffTotal = 0
  order.discountCustomerTotal = 0
  order.surchargeProductTotal = 0
  order.costTotal = 0
  order.taxMoney = 0
  order.totalAfterTaxProduct = 0
  order.invoiceInitials = order.invoiceInitials || []
  order.totalProductQuantity = 0
  order.totalGiftQuantity = 0
  order.branchId = order.branchId || Vue.prototype.$branchId
  order.priceLevelId = order.priceLevelId || Vue.prototype.$priceLevelId
  order.shipData = _.first(order.shipping) || {}
  const priceLevel = Vue.prototype.$priceLevels.find(
    (a) => a.id == order.priceLevelId,
  )
  if (priceLevel && !order.id) {
    order.currency = priceLevel.currency || Vue.prototype.$currency
    order.exchangeRate = priceLevel.exchangeRate || 1
  }
  order.exchangeRate = order.exchangeRate || 1
  order.currency = order.currency || Vue.prototype.$currency

  const rate = Vue.prototype.$exchangeList.find(
    (a) => a.currency == order.currency,
  )
  order.symbol = order.currency
  if (rate) {
    order.symbol = rate.symbol || 1
  }

  if (!order.sameTax) {
    order.percentTax = 0
  }
  order.invoiceInitials
    .filter((i) => !i.isDelete)
    .map((item) => {
      // item unit
      item.groupName =
        item.groupName ||
        (item.isGift ? "Quà" : "") ||
        (item.isCost ? "Chi phí" : "")
      item.foreignAmount = item.productPrice / order.exchangeRate
      if (!order.quoteId) {
        if (item.productPrices && item.productPrices.length && !order.id) {
          var priceItem = item.productPrices.find(
            (a) =>
              a.branches.id == order.branchId &&
              a.priceLevel.id == order.priceLevelId,
          )

          item.productPrice = item.priceDefault
          item.foreignAmount = item.priceDefault
          if (priceItem && priceItem.price) {
            item.productPrice = round(priceItem.price * order.exchangeRate)
            item.foreignAmount = priceItem.price
          }
        }
      }
      if (item.isGift) {
        item.productPrice = 0
      }
      item.costPrice = item.costPrice || 0
      item.surchargeType = item.surchargeType || "MONEY"
      item.saleOffType = item.saleOffType || "MONEY"

      if (item.saleOffType == "PERCENT" && item.saleOffValue > 100) {
        item.saleOffValue = 100
      }
      item.percentTax = item.percentTax || 0
      item.surchargeValue = item.surchargeValue || 0
      item.saleOffValue = item.saleOffValue || 0
      if (Math.abs(item.saleOffValue) > Math.abs(item.productPrice)) {
        item.saleOffValue = item.productPrice
      }

      item.discountCustomerPercent = item.discountCustomerPercent || 0
      item.saleOffMoney =
        item.saleOffType == "PERCENT"
          ? (item.saleOffValue / 100) * item.productPrice
          : item.saleOffValue
      item.surchargeMoney =
        item.surchargeType == "PERCENT"
          ? (item.surchargeValue / 100) * item.productPrice
          : item.surchargeValue

      item.discountCustomerMoney =
        item.discountCustomerPercent * 0.01 * item.productPrice
      item.totalDiscount = item.saleOffMoney + item.discountCustomerMoney
      item.priceAfter =
        item.productPrice - item.totalDiscount + item.surchargeMoney

      item.rawQuantity = item.productQuantity
      item.cashSaleOff = round(item.rawQuantity * item.saleOffMoney)

      item.discountCustomer = round(
        item.rawQuantity * item.discountCustomerMoney,
      )
      item.surcharge = round(item.rawQuantity * item.surchargeMoney)
      item.costTotal = round(item.rawQuantity * item.costPrice)

      item.total = round(item.productPrice * item.rawQuantity)

      item.totalPayment =
        item.total - item.cashSaleOff - item.discountCustomer + item.surcharge

      // for unit conversion
      item.unitName = item.unitName || item.products.unit.name
      var exchangeUnit =
        Vue.prototype.$units.find((a) => a.name == item.unitName) || {}
      item.exchangeUnits = [
        {
          transferName: item.unitName,
          transferValue: 1,
        },
      ]
        .concat(exchangeUnit.transferUnits)
        .filter(a=>a)
        .map((a) => {
          return {
            name: a.transferName,
            id: a.transferName,
            transfer: a.transferValue,
          }
        })

      item.transferUnit = item.transferUnit || item.unitName

      var t = item.exchangeUnits.find((a) => a.name == item.transferUnit)

      item.transfer = t ? t.transfer : 1
      item.priceUnit = item.productPrice * item.transfer
      item.quantityUnit = item.productQuantity / item.transfer
      item.priceCurrency = item.priceUnit / order.exchangeRate

      item.totalCurrency = item.total / order.exchangeRate
      order.beforeSaleOffTotal += item.total
      order.saleOffTotal += item.cashSaleOff
      order.discountCustomerTotal += item.discountCustomer
      order.surchargeProductTotal += item.surcharge
      order.costTotal += item.costTotal

      total += item.totalPayment
      order.totalQuantity += item.rawQuantity

      if (item.isGift) {
        order.totalGiftQuantity += item.rawQuantity
      } else {
        order.totalProductQuantity += item.rawQuantity
      }

      if (item.isBundle) {
        item.children.forEach((child) => {
          child.rawQuantity = child.bundleQuantity * item.rawQuantity
          child.productQuantity = child.rawQuantity
          child.costTotal = child.rawQuantity * child.costPrice
          order.costTotal += child.costTotal
        })
      }
    })

  order.invoiceInitials = order.invoiceInitials.filter(
    (i) => i.productQuantity > 0,
  )

  order.groupNames = [
    ...new Set(order.invoiceInitials.map((i) => i.groupName)),
  ].sort((a, b) => (a > b ? 1 : -1))
  order.totalQuantity = round(order.totalQuantity * 100) / 100
  order.total = total

  order.totalDiscountInvoice = 0

  if (order.isMemberDiscount) {
    order.membershipDiscountPercent = order.customer.discountPercent || 0
    order.membershipDiscountMoney =
      (order.total * order.membershipDiscountPercent) / 100
  } else {
    order.membershipDiscountPercent = 0
    order.membershipDiscountMoney = 0
  }
  order.totalDiscountInvoice += order.membershipDiscountMoney
  order.numberPointConvert = order.numberPointConvert || 0
  order.pointToMoney = order.pointToMoney || 1

  order.moneyPointConvert = round(order.numberPointConvert * order.pointToMoney)

  if (
    Math.abs(order.moneyPointConvert) >
    Math.abs(total - order.membershipDiscountMoney)
  ) {
    order.moneyPointConvert = total - order.membershipDiscountMoney
    order.numberPointConvert = round(
      order.moneyPointConvert / order.pointToMoney,
    )
  }
  order.totalDiscountInvoice += order.moneyPointConvert

  order.memberShipAmount =
    order.moneyPointConvert + order.membershipDiscountMoney

  const totalAfterMember = total - order.totalDiscountInvoice

  order.voucherDiscount = 0
  order.couponDiscount = 0
  // order.cashDiscount = 0;
  order.cashDiscountPercent =
    round((order.cashDiscountPercent || 0) * 100) / 100

  if (order.invoiceDiscounts) {
    order.invoiceDiscounts
      .filter((i) => !i.isDelete)
      .map((item) => {
        if (item.discountType === "PERCENT") {
          item.discountMoney = (item.discountValue * totalAfterMember) / 100
          order.couponDiscount += item.discountMoney
        } else {
          item.discountMoney = item.discountValue
          order.voucherDiscount += item.discountMoney
        }
      })
  }
  if (Math.abs(order.voucherDiscount) > Math.abs(totalAfterMember)) {
    order.voucherDiscount = totalAfterMember
  }
  if (Math.abs(order.couponDiscount) > Math.abs(totalAfterMember)) {
    order.couponDiscount = totalAfterMember
  }

  order.totalDiscountInvoice += order.couponDiscount
  order.totalDiscountInvoice += order.voucherDiscount

  const totalAfterDiscount =
    totalAfterMember - order.voucherDiscount - order.couponDiscount
  order.cashDiscountType = order.cashDiscountType || "MONEY"
  order.cashDiscount = order.cashDiscount || 0
  order.cashDiscountPercent = order.cashDiscountPercent || 0

  if (order.cashDiscountType == "MONEY") {
    order.cashDiscountPercent = (order.cashDiscount * 100) / totalAfterDiscount
    order.cashDiscountPercent =
      round((order.cashDiscountPercent || 0) * 100) / 100
  } else {
    if (order.cashDiscountPercent > 100) {
      order.cashDiscountPercent = 100
    }
    order.cashDiscount = totalAfterDiscount * order.cashDiscountPercent * 0.01
  }

  if (Math.abs(order.cashDiscount) > Math.abs(totalAfterDiscount)) {
    if (order.cashDiscountType == "MONEY") {
      order.cashDiscount = totalAfterMember - order.voucherDiscount
      order.cashDiscountPercent =
        (order.cashDiscount * 100) / totalAfterDiscount
    }
  }

  order.cashDiscount = round(order.cashDiscount)
  order.totalDiscountInvoice += order.cashDiscount
  order.surcharges = order.surcharges || []
  order.surcharge = order.surcharges
    .filter((i) => !i.isDelete)
    .reduce((a, b) => a + b.amount, 0)

  order.surchargeOrder = order.surcharges
    .filter((i) => !i.isDelete && !i.invoiceProcessSteps)
    .reduce((a, b) => a + b.amount, 0)

  order.totalSurcharge = order.surcharge + order.surchargeProductTotal

  order.totalDiscount =
    order.totalDiscountInvoice +
    order.saleOffTotal +
    order.discountCustomerTotal

  order.totalDiscountProduct = order.saleOffTotal + order.discountCustomerTotal

  order.invoiceInitials = order.invoiceInitials.map((item) => {
    if (order.beforeSaleOffTotal) {
      item.percent = item.total / order.beforeSaleOffTotal
    } else {
      item.percent = item.rawQuantity / order.totalQuantity
    }

    if (order.totalQuantity == 0) {
      item.percent = 100
    }

    item.orderSaleOff = round(item.percent * order.totalDiscountInvoice)
    item.orderSaleOffItem = item.orderSaleOff / item.rawQuantity

    item.orderSurcharge = round(item.percent * order.surcharge)
    item.orderSurchargeItem = item.orderSurcharge / item.rawQuantity

    item.totalBeforeTax =
      item.totalPayment - item.orderSaleOff + item.orderSurcharge

    if (order.sameTax) {
      item.percentTax = order.percentTax
    }

    item.taxMoney = item.totalBeforeTax * item.percentTax * 0.01
    item.totalAfterTax = item.totalBeforeTax + item.taxMoney

    item.priceItem = round((100 * item.totalBeforeTax) / item.rawQuantity) / 100
    item.priceItemUnit = item.priceItem * item.transfer

    item.priceItemAfterTax =
      round((100 * item.totalAfterTax) / item.rawQuantity) / 100
    item.priceItemAfterTaxUnit = item.priceItemAfterTax * item.transfer

    order.taxMoney += item.taxMoney
    order.totalAfterTaxProduct += item.totalAfterTax

    return item
  })

  order.taxMoney = round(order.taxMoney)

  order.grandTotalBeforeTax =
    order.beforeSaleOffTotal - order.totalDiscount + order.totalSurcharge

  order.grandTotal = round(order.grandTotalBeforeTax + order.taxMoney)
  order.invoiceCardPayments = order.invoiceCardPayments || []
  order.invoiceCashPayments = order.invoiceCashPayments || []

  order.invoiceCashPayments = order.invoiceCashPayments.filter(
    (i) => i.totalPayment,
  )
  order.invoiceCardPayments = order.invoiceCardPayments.filter(
    (i) => i.totalPayment,
  )

  order.extraCash = round(
    order.invoiceCashPayments
      .filter((a) => a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )

  order.extraCard = round(
    order.invoiceCardPayments
      .filter((a) => a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )

  order.extraMoney = round(order.extraCash + order.extraCard)

  order.cashTotal = round(
    order.invoiceCashPayments
      .filter((a) => !a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )
  order.cardTotal = round(
    order.invoiceCardPayments
      .filter((a) => !a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )

  order.cashTotalMoney = round(
    order.invoiceCashPayments
      .filter((a) => a.totalPayment > 0 && !a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )
  order.cashTotalReturnMoney =
    -1 *
    order.invoiceCashPayments
      .filter((a) => a.totalPayment < 0)
      .reduce((a, b) => a + b.totalPayment, 0)

  order.cardTotalMoney = round(
    order.invoiceCardPayments
      .filter((a) => a.totalPayment > 0 && !a.isExtra)
      .reduce((a, b) => a + b.totalPayment, 0),
  )
  order.cardTotalReturnMoney =
    -1 *
    round(
      order.invoiceCardPayments
        .filter((a) => a.totalPayment < 0)
        .reduce((a, b) => a + b.totalPayment, 0),
    )

  order.totalMoney = round(order.cashTotalMoney + order.cardTotalMoney)
  order.totalMoneyReturn = round(
    order.cashTotalReturnMoney + order.cardTotalReturnMoney - order.extraMoney,
  )

  order.remainPayment = round(
    order.grandTotal - (order.cardTotal + order.cashTotal),
  )
  order.paidMoney = round(order.cardTotal + order.cashTotal)

  order.needRefundPayment = 0
  if (order.remainPayment <= 0) {
    order.needRefundPayment = round(order.remainPayment * -1)
    order.remainPayment = 0
    order.paymentStatus = "PAID"
  } else if (order.remainPayment == order.grandTotal) {
    order.paymentStatus = "UNPAID"
  } else {
    order.paymentStatus = "PARTIAL_PAID"
  }

  order.employeeSales = (order.employeeSales || []).map((i) => {
    return {
      id: i.id,
      isDelete: i.isDelete,
      employeeId: i.employeeId,
      employeeName: i.employeeName,
      percentSale: i.percentSale,
      moneySale: i.percentSale * order.grandTotalBeforeTax * 0.01,
    }
  })

  order.invoiceProcessSteps = order.invoiceProcessSteps || []
  order.invoiceProcessSteps = (order.invoiceProcessSteps || []).map(
    (process) => {
      return countPriceProcess(process, order)
    },
  )
  order.totalDebt = _.sumBy(
    order.invoiceProcessSteps.filter((a) => a.isDebt),
    "grandTotal",
  )

  order.remainDebt = order.totalDebt - order.paidMoney

  var channel = Vue.prototype.$channels.find(
    (a) => a.name == order.channel,
  ) || { isOnline: false }
  order.isOnline = channel.isOnline

  const totalProductNeed = _.sumBy(order.invoiceInitials, "productQuantity")
  const totalProductStock = _.sumBy(
    _.flatMap(
      order.invoiceProcessSteps.filter(
        (a) => a.doneStock && a.processStatus == "DONE",
      ),
      "products",
    ),
    "productQuantity",
  )

  if (totalProductStock < totalProductNeed) {
    order.stockStatus = "PROCESSING"
  }

  if (totalProductStock == 0) {
    order.stockStatus = "UNFINISHED"
  }

  if (totalProductStock == totalProductNeed) {
    order.stockStatus = "FINISHED"
  }

  return order
}

export const countPriceProcess = (process, order) => {
  const round = Vue.prototype.$round
  process.total = 0
  process.costTotal = 0
  process.totalQuantity = 0
  process.beforeSaleOffTotal = 0
  process.discountCustomer = 0
  process.surchargeProductTotal = 0
  process.saleOffTotal = 0
  process.taxMoney = 0
  process.products = process.products || process.stepInitsReqs || []
  process.products
    .filter((a) => !a.isDelete)
    .map((item) => {
      item.quantity =
        item.quantity === undefined ? item.productQuantity : item.quantity

      item.productPrice = item.productPrice || 0
      item.costPrice = item.costPrice || 0

      if (item.isGift) {
        item.productPrice = 0
      }
      item.surchargeValue = item.surchargeValue || 0
      item.saleOffValue = item.saleOffValue || 0
      item.discountCustomerPercent = item.discountCustomerPercent || 0
      item.saleOffMoney =
        item.saleOffType == "PERCENT"
          ? (item.saleOffValue / 100) * item.productPrice
          : item.saleOffValue
      item.surchargeMoney =
        item.surchargeType == "PERCENT"
          ? (item.surchargeValue / 100) * item.productPrice
          : item.surchargeValue

      item.discountCustomerMoney =
        item.discountCustomerPercent * 0.01 * item.productPrice
      item.priceAfter =
        item.productPrice -
        item.saleOffMoney -
        item.discountCustomerMoney +
        item.surchargeMoney

      item.cashSaleOff = round(item.quantity * item.saleOffMoney)
      item.discountCustomer = round(item.quantity * item.discountCustomerMoney)
      item.surcharge = round(item.quantity * item.surchargeMoney)
      item.costTotal = round(item.quantity * item.costPrice)
      item.total = round(item.productPrice * item.quantity)

      item.totalPayment =
        item.total - item.cashSaleOff - item.discountCustomer + item.surcharge
      //console.log(item);

      // for unit conversion
      item.unitName = item.unitName || item.products.unit.name
      var exchangeUnit =
        Vue.prototype.$units.find((a) => a.name == item.unitName) || {}
      item.exchangeUnits = [
        {
          transferName: item.unitName,
          transferValue: 1,
        },
      ]
        .concat(exchangeUnit.transferUnits)
        .filter(a=>a)
        .map((a) => {
          return {
            name: a.transferName,
            id: a.transferName,
            transfer: a.transferValue,
          }
        })

      item.transferUnit = item.transferUnit || item.unitName
      var t = item.exchangeUnits.find((a) => a.name == item.transferUnit)

      item.transfer = t ? t.transfer : 1
      item.priceUnit = item.productPrice * item.transfer
      item.quantityUnit = item.quantity / item.transfer

      item.priceCurrency = item.priceUnit / order.exchangeRate
      item.totalCurrency = item.total / order.exchangeRate

      process.surchargeProductTotal += item.surcharge
      process.discountCustomer += item.discountCustomer
      process.total += item.totalPayment
      process.costTotal += item.costTotal
      process.totalQuantity += item.quantity
      process.beforeSaleOffTotal += item.total
      process.saleOffTotal += item.cashSaleOff
    })

  if (order.total == 0) {
    if (order.totalQuantity == 0) {
      process.percentDone = 1
    } else {
      process.percentDone = process.totalQuantity / order.totalQuantity
    }
  } else {
    process.percentDone = process.total / order.total
  }
  process.percentDone = Math.abs(process.percentDone)

  process.cashDiscount = round(order.cashDiscount * process.percentDone)
  if (process.isProcessReturn) {
    process.cashDiscount = process.cashDiscount * -1
  }

  process.voucherDiscount = round(order.voucherDiscount * process.percentDone)

  process.couponDiscount = round(order.couponDiscount * process.percentDone)

  process.moneyPointConvert = round(
    order.moneyPointConvert * process.percentDone,
  )

  process.membershipDiscountMoney = round(
    order.membershipDiscountMoney * process.percentDone,
  )

  process.surchargeProcess = (process.surcharges || [])
    .filter((a) => !a.isDelete)
    .reduce((a, b) => a + +b.amount, 0)

  process.surchargeOrder = round(order.surchargeOrder * process.percentDone)
  process.surcharge = process.surchargeProcess + process.surchargeOrder

  process.totalDiscount =
    process.cashDiscount +
    process.voucherDiscount +
    process.couponDiscount +
    process.membershipDiscountMoney +
    process.moneyPointConvert
  process.products = (process.products || []).map((item) => {
    if (process.beforeSaleOffTotal) {
      item.percent = item.total / process.beforeSaleOffTotal
    } else {
      item.percent = item.quantity / process.totalQuantity
    }
    item.percent = item.percent || 0

    item.orderSaleOff = round(item.percent * process.totalDiscount)
    item.orderSaleOffItem = item.orderSaleOff / item.quantity

    item.orderSurcharge = round(item.percent * process.surcharge)
    item.orderSurchargeItem = item.orderSurcharge / item.quantity

    item.totalBeforeTax =
      item.totalPayment - item.orderSaleOff + item.orderSurcharge

    item.taxMoney = round(item.totalBeforeTax * item.percentTax * 0.01)

    process.taxMoney += item.taxMoney

    item.totalAfterTax = item.totalBeforeTax + item.taxMoney

    // item.priceItem = item.totalBeforeTax / item.quantity
    // if(!item.priceItem){
    //   item.priceItem =
    // }

    item.priceItem = round((100 * item.totalBeforeTax) / item.quantity) / 100
    item.priceItemUnit = item.priceItem * item.transfer

    item.priceItemAfterTax =
      round((100 * item.totalAfterTax) / item.quantity) / 100
    item.priceItemAfterTaxUnit = item.priceItemAfterTax * item.transfer

    return item
  })

  process.groupNames = [
    ...new Set(process.products.map((i) => i.groupName)),
  ].sort((a, b) => (a > b ? 1 : -1))
  process.grandTotalBeforeTax = round(
    process.total - process.totalDiscount + process.surcharge,
  )

  process.grandTotal = round(process.taxMoney + process.grandTotalBeforeTax)

  return process
}

export const autoFulfillOrder = (_this, _order) => {
  const stock =
    _this.$branch.stocks.find((s) => s.isDefault) || _this.$branch.stocks[0]
  if (!stock) {
    throw new Error("Vui lòng tạo kho hàng cho chi nhánh trước khi tiếp tục")
  }
  const order = countPriceB2B(_order)
  order.invoiceInitials = order.invoiceInitials.map((p) => {
    return {
      ...p,
      productId: p.productId || p.products.id,
    }
  })
  if (!order.invoiceDetails.length) {
    order.invoiceProcessSteps = [
      {
        id:
          order.invoiceProcessSteps && order.invoiceProcessSteps[0]
            ? order.invoiceProcessSteps[0].id
            : undefined,
        stepName: "Tạo tự động cho đơn bán lẻ",
        products: order.invoiceInitials.map((p) => {
          return {
            ...p,
            productId: p.productId,
            productQuantity: p.productQuantity,
            isGift: p.isGift,
            stocks: p.stocks,
            id: undefined,
          }
        }),
        isDebt: true,
        doneStock: true,
        surcharges: [],
        processStatus: "DONE",
        description: "Tạo tự động cho đơn bán lẻ",
        subStatus: "done",
        employeeSaleProcessReqs: [
          {
            employeeId: order.personInChargeId,
            money: order.grandTotal || 0,
          },
        ],
        costTotal: order.costTotal,
        total: order.total,
        beforeSaleOffTotal: order.beforeSaleOffTotal,
        saleOffTotal: order.saleOffTotal,
        discountCustomer: order.discountCustomerTotal,
        surchargeProductTotal: order.surchargeProductTotal,
        taxMoney: order.taxMoney,
        grandTotal: order.grandTotal,
        cashDiscount: order.cashDiscount,
        voucherDiscount: order.voucherDiscount,
        couponDiscount: order.couponDiscount,
        membershipDiscountMoney: order.membershipDiscountMoney,
        moneyPointConvert: order.moneyPointConvert,
        totalDiscount: order.totalDiscount,
        invoiceDetails: order.invoiceInitials.map((p) => {
          return {
            productId: p.productId,
            productQuantity: p.productQuantity,
            productPrice: p.productPrice,
            costPrice: p.costPrice,
            totalPayment: p.totalPayment,
            costTotal: p.costTotal,
            cashSaleOff: p.cashSaleOff,
            saleOffValue: p.saleOffValue,
            saleOffType: p.saleOffType,
            total: p.total,
            stocks: [
              {
                quantity: p.productQuantity,
                stockId: stock.id,
                stockName: stock.stockName,
                batchName: stock.batchName,
                expiryDate: stock.expiryDate,
                manufacturingDate: stock.manufacturingDate,
              },
            ],
            isBundle: false,
            levelId: order.priceLevelId,
            isGift: false,
            discountCustomer: p.discountCustomer,
            discountCustomerPercent: p.discountCustomerPercent,
            taxMoney: p.taxMoney,
            percentTax: p.percentTax,
            totalAfterTax: p.totalAfterTax,
            totalBeforeTax: p.totalBeforeTax,
            orderSurcharge: p.orderSurcharge,
            orderSaleOff: p.orderSaleOff,
            surcharge: p.surcharge,
            surchargeValue: p.surchargeValue,
            surchargeType: p.surchargeType,
          }
        }),
      },
    ]
  }

  order.orderStatus = "FINISHED"
  order.stockStatus = "FINISHED"

  const d = toJsonOrder(countPriceB2B(order))
  return d
}

export const refundPayment = async (selected, _this, cb) => {
  var res = await _this.$api.getInvoicesSummary(
    { branchId: _this.$branchId, id_in: selected },
    selected.length,
    0,
    "id_desc",
  )
  var orders = res.list.map((a) => {
    a.cardTotal - a.cashTotal > 0
    return a
  })
  if (!orders.length) {
    _this.$noti.open("Những hoá đơn bạn chọn đã hoàn đủ tiền", true)
    return
  }
  var total = orders.reduce((a, b) => a + b.cardTotal + b.cashTotal, 0)

  var accountantCash = _this.$financeAuto.find(
    (i) => i.keyPayment == "REFUND_CASH",
  )

  const inputs = [
    {
      title: `Số tiền hoàn trả (max: ${_this.$formatMoney(total)})`,
      key: "total",
      required: true,
      value: total,
      width: "40%",
      type: "price",
      disabled: orders.length != 1,
      max: total,
    },
    {
      title: "Hoàn tiền qua",
      key: "paymentType",
      required: true,
      width: "60%",
      type: "select",
      value: "CASH",
      selectList: orders[0].customers
        ? _this.$paymentTypes
        : _this.$paymentTypes.filter((a) => a.value != "DEBIT"),
    },
    {
      title: "Người nộp",
      key: "transferRepresent",
      required: true,
      width: "50%",
      value: _this.$user.fullName,
    },

    {
      title: "Người nhận",
      key: "receiverRepresent",
      required: true,
      width: "50%",
      value:
        (orders.length > 0 &&
          orders[0].customers &&
          orders[0].customers.customerName) ||
        "Khách lẻ",
    },

    {
      title: "Thông tin - địa chỉ người nộp",
      key: "address",
      width: "100%",
      value: _this.$user.fullName,
    },
    {
      title: "Ghi chú",
      key: "des",
      width: "100%",
      type: "textarea",
      value: `Hoàn tiền cho đơn hàng ${orders.map((i) => i.code).join(", ")}`,
    },
    {
      title: "Tài khoản kế toán",
      type: "title",
    },
    {
      title: "Yếu tố chi",
      key: "elementCode",
      width: "50%",
      type: _this.$financeCodes.filter((a) => a.accountantType == "EXPENSE")
        .length
        ? "select"
        : "text",
      selectList: _this.$financeCodes.filter(
        (a) => a.accountantType == "EXPENSE",
      ),
    },

    {
      title: "Quyển số",
      key: "bookNo",
      width: "25%",
    },

    {
      title: "Số phiếu",
      key: "codeNumber",
      width: "25%",
    },
    {
      title: "Mã ĐTPN nộp (có)",
      key: "transferCode",
      width: "50%",
      disabled: !!_this.$user.employeeCode,
      value: _this.$user.employeeCode,
    },

    {
      title: "Mã ĐTPN nhận (nợ)",
      key: "receiverCode",
      width: "50%",
      disabled: true,

      value:
        (orders.length > 0 &&
          orders[0].customers &&
          orders[0].customers.customerCode) ||
        "KHACH_LE",
    },

    {
      title: "ĐTPN nộp (có)",
      key: "transfer",
      width: "50%",
      value: _this.$user.fullName,
    },
    {
      title: "ĐTPN nhận (nợ)",
      key: "receiver",
      width: "50%",

      value:
        (orders.length > 0 &&
          orders[0].customers &&
          orders[0].customers.customerName) ||
        "Khách lẻ",
    },

    {
      title: "Tải khoản có",
      key: "debtAccId",
      width: "50%",
      type: "select",
      selectList: _this.$accountList,
      value: accountantCash && accountantCash.credit.id,
    },
    {
      title: "Tải khoản nợ",
      key: "availableAccId",
      width: "50%",
      selectList: _this.$accountList,
      value: accountantCash && accountantCash.debt.id,
      type: "select",
    },
  ]

  const config = {
    title:
      orders.length == 1
        ? `Hoàn tiền cho đơn ${orders[0].code} - (${_this.$formatMoney(total)})`
        : `Hoàn tiền cho ${orders.length} đơn - (${_this.$formatMoney(total)})`,
  }
  _this.$root.formPopup.openPopup(inputs, config, (res) => {
    var incomeData = []
    var remain = res.total
    var invoices = orders.map((i) => {
      const item = {
        id: i.id,
        orderStatus: i.orderStatus,
        paymentStatus: i.paymentStatus,
        remainPayment: 0,
      }
      if (res.paymentType == "CASH" || res.paymentType == "DEBIT") {
        item.invoiceCashPayments = [
          {
            currencyUnit: Vue.prototype.$currency,
            totalCash: remain * -1,
            totalPayment: remain * -1,
            exchangePrice: 1,
            isDebit: res.paymentType == "DEBIT",
          },
        ]
        item.invoiceCardPayments = []
        item.totalCash = i.cashTotal + remain * -1
        item.totalCard = i.cardTotal + 0
      } else {
        item.invoiceCashPayments = []
        item.invoiceCardPayments = [
          {
            totalPayment: remain * -1,
            cardType: res.paymentType.split("&&")[0],
            cardNumber: res.paymentType.split("&&")[1],
          },
        ]

        item.totalCard = i.cardTotal + remain * -1
        item.totalCash = i.cashTotal + 0
      }
      item.paidMoney = item.totalCash + item.totalCard
      item.remainDebt = i.totalDebt - item.paidMoney
      item.remainPayment = i.grandTotal - item.paidMoney

      remain = remain - i.remainPayment
      if (remain < 0) {
        remain = 0
      }

      if (item.remainPayment > 0) {
        item.paymentStatus = "PARTIAL_PAID"
      }
      if (item.remainPayment == 0) {
        item.paymentStatus = "PAID"
      }
      if (item.remainPayment == item.grandTotal) {
        item.paymentStatus = "UNPAID"
      }
      return item
    })

    var paymentReqs = []
    if (res.debtAccId && res.availableAccId && res.total > 0) {
      paymentReqs.push({
        debtAccId: res.debtAccId,
        availableAccId: res.availableAccId,
        totalPayment: res.total,

        transfer: res.transfer,
        receiver: res.receiver,
        receiverCode: res.receiverCode,
        transferCode: res.transferCode,
      })
    }

    if (paymentReqs && paymentReqs.length) {
      var elment = _this.$financeCodes.find((a) => a.id == res.elementCode)
      incomeData.push({
        bookNo: res.bookNo,
        codeNumber: res.codeNumber,
        elementCode: res.elementCode,
        elementName: elment ? elment.name : res.elementCode,
        totalPayment: res.total,
        transfer: res.transfer,
        transferRepresent: res.transferRepresent,
        receiver: res.receiver,
        receiverRepresent: res.receiverRepresent,
        receiverCode: res.receiverCode,
        transferCode: res.transferCode,

        accountantType: "EXPENSE",
        paymentReqs: paymentReqs,
        address: res.address,
        paymentDetailReqs: {
          currencyUnit: _this.$currency,
          originalCurrency: res.total,
          exchangePrice: 1,
          totalPayment: res.total,
          isCashPayment: res.paymentType == "CASH",
        },
        description: res.des,
      })
    }
    _this.$root.formPopup.sending = true

    _this.$api
      .paymentInvoice(invoices, incomeData, _this.$branchId)
      .then(async () => {
        _this.$noti.open(_this.$t("common.payment_success"))
        _this.$root.formPopup.closePopup()

        // invoices.forEach((i) => {
        for (let item of invoices) {
          const oldOrder = orders.find((a) => a.id == item.id)
          var totalDebit = item.invoiceCashPayments
            .filter((a) => a.isDebit)
            .reduce((a, b) => a + b.totalPayment, 0)
          if (totalDebit != 0 && oldOrder) {
            const dataCredit = {
              customerId: oldOrder.customers ? oldOrder.customers.id : "",
              transfer: oldOrder.customers
                ? oldOrder.customers.customerName
                : "",
              receiver: _this.$user.fullName,
              creditDate: moment().format("YYYY-MM-DD"),
              money: totalDebit * -1,
              description: "Trả tiền đơn trả hàng " + oldOrder.code,
              branchId: _this.$branchId,
            }
            await _this.$api.newCredit(dataCredit, _this.$companyId, [])
          }
        }

        cb({ invoices, paymentType: res.paymentType })
      })
      .catch(() => {
        _this.$root.formPopup.sending = false
      })
  })
}

export const getFieldInvoice = (_this, isRaw, viewDetail) => {
  const subStatuses = []
  const invoiceCustomFields = _this.$customFieldsColumns("Invoices").map(
    (field) => {
      if (field.key !== "cf._dateShipping") return field

      const getShippingDate = (row) => {
        const customFields = _this.$customFieldsToJson(
          row.customFieldValues || [],
        )
        return customFields._dateShipping || row.orderBulk?.dateTime || ""
      }

      return {
        ...field,
        showData: (row) => {
          const shippingDate = getShippingDate(row)
          return shippingDate ? _this.$formatDate(shippingDate) : "-"
        },
        showDataRaw: (row) => getShippingDate(row),
      }
    },
  )
  const inputs = [
    {
      title: "Mã đơn hàng",
      key: "code",
      searchKey: "code_ilike",
      className: "pointer nobreak",
      showDataRaw: (r) => r.code,
      showData: (row) => {
        var out = ""
        var type = row.isB2B
          ? "Bán sỉ"
          : row.orderType == "SALES"
            ? "Bán POS"
            : "Bán lẻ"
        if (row.orderType == "RETURN_PRODUCT") {
          out += `
            <p class="m-0 font-12">(Trả hàng)</p>
              <p class="bold text-danger">
            <i class="mdi mdi-cart-off" ></i>
            ${row.code}
            </p>
            `
        } else {
          out += `
            <p class="m-0 font-12">
          ${type}
          </p>
          <p class="bold text-success"><i class="mdi mdi-cart" /></i>
            ${row.code}
          </p>
          `
        }
        return (
          out + `<p class="sub-text w-200px text-trim">${row.title || ""}</p>`
        )
      },
      click: (row) => {
        viewDetail && viewDetail(row)
      },
      width: "100%",
    },
    {
      title: "Loại đơn",
      showData: (r) => {
        return r.isB2B
          ? "Bán sỉ"
          : r.orderType == "SALES"
            ? "Bán POS"
            : "Bán lẻ"
      },
      key: "orderType",
      searchType: "select",
      searchList: [
        { name: "Bán sỉ", id: "DEBT_B2B" },
        { name: "Bán POS", id: "SALES" },
        { name: "Bán lẻ", id: "DEBT" },
        { name: "Trả hàng", id: "RETURN_PRODUCT" },
      ],
    },
    {
      key: "contracts.contractName",
      searchKey: [
        "contracts.contractName_ilike",
        "contracts.contractCode_ilike",
      ],
      width: "200px",
      title: "Hợp đồng",
      showData: (row) => {
        if (!row.contracts) return "-"
        return `<p>${
          row.contracts && row.contracts.contractName
        }<br /> <small>(${
          row.contracts && row.contracts.contractCode
        })</small></p>`
      },
    },
    {
      key: "channels",
      searchKey: "channels_in",
      title: "Kênh bán",
      className: "nobreak",
      showData: (row) => row.channels,
      searchType: "multi-select",
      searchList: _this.$channels.map((a) => ({ ...a, id: a.name })),
    },

    // {
    //   title: "Người tạo",
    //   key: "invoiceCreateByUserName_ilike",
    //   searchKey: "invoiceCreateByUserName_ilike",
    //   className: "nobreak",
    //   showData: (r) =>
    //     `<p>${r.invoiceCreateByUserName}</p>
    //     <p class="m-0 font-12">
    //       ${_this.$formatDate(r.createdAt)}
    //       |
    //       ${_this.$formatTime(r.createdAt)}
    //     </p>`,
    //   showDataRaw: (r) => r.invoiceCreateByUserName,
    // },

    {
      title: "NV phụ trách",
      key: "personInCharge.fullName",
      searchKey: [
        "personInCharge.fullName_ilike",
        "personInCharge.employeeCode_ilike",
      ],
      className: "nobreak",
      showData: (r) => r.personInCharge && r.personInCharge.fullName,
    },

    {
      title: "NV hưởng doanh số",
      key: "employeeSales.employeeId",
      searchType: "multi-select",
      searchList: _this.$branch.employeeBranches.map((a) => ({
        id: a.employees.id,
        name: a.employees.fullName,
      })),
      showData: (r) =>
        (r.employeeSales || [])
          .map(
            (a) =>
              `<span class="nobreak">${a.employeeName} (${a.percentSale}%) </span>`,
          )
          .join(", "),
      showDataRaw: (r) =>
        (r.employeeSales || []).map((a) => a.employeeName).join("\n"),
    },
    {
      title: "Tỉ lê NV hưởng doanh số",
      key: "employeeSales.percentSale",
      showData: (r) =>
        (r.employeeSales || []).map((a) => a.percentSale).join("\n"),
      hide: true,
    },
    {
      title: "Ngày tạo",
      key: "createdAt",
      searchType: "date-range",
      showData: (r) =>
        `${_this.$formatDate(r.createdAt)} |  ${_this.$formatTime(
          r.createdAt,
        )} `,
      showDataRaw: (r) =>
        r.createdAt ? `${_this.$formatDate(r.createdAt)}` : "",
    },
    {
      title: "Giờ tạo",
      key: "createdAt",
      hide: true,
      showData: (r) => `${_this.$formatTime(r.createdAt)}`,
      showDataRaw: (r) =>
        r.createdAt ? `${_this.$formatTime(r.createdAt)}` : "",
    },
    {
      title: "Ngày báo cáo",
      searchType: "date-range",
      key: "invoiceDate",
      showData: (r) =>
        `${_this.$formatDate(r.invoiceDate)} |  ${_this.$formatTime(
          r.invoiceDate,
        )}`,
      showDataRaw: (r) =>
        r.invoiceDate ? `${_this.$formatDate(r.invoiceDate)}` : "",
    },
    {
      title: "Giờ báo cáo",
      hide: true,
      key: "invoiceTimeDate",
      showData: (r) => `${_this.$formatTime(r.invoiceDate)}`,
      showDataRaw: (r) =>
        r.invoiceDate ? `${_this.$formatTime(r.invoiceDate)}` : "",
    },

    {
      key: "stockStatus",
      title: "Trạng thái hàng",
      showData: (row) => {
        if (row.stockStatus === "FINISHED") {
          return `<span class="status status-success">Đã giao xong</span>`
        } else if (row.stockStatus === "PROCESSING") {
          return `<span class="status status-info">Đang xử lý</span>`
        } else if (row.stockStatus === "UNFINISHED") {
          return `<span class="status status-warning">Chưa giao</span>`
        }
      },
      className: "nobreak",
      searchType: "multi-select",
      minWidth: "100px",
      searchList: [
        { id: "FINISHED", name: "Đã hoàn thành" },
        { id: "PROCESSING", name: "Đang xử lý" },
        { id: "UNFINISHED", name: "Chưa hoàn thành" },
        { id: "DELETED", name: "Đã xoá" },
        { id: "CANCEL", name: "Đã huỷ" },
      ],
    },
    {
      key: "paymentStatus",
      title: _this.$t("sale.payment_status"),
      className: "nobreak",
      searchType: "multi-select",
      minWidth: "100px",
      searchList: [
        { id: "PENDING", name: "Chờ thanh toán" },
        { id: "PROCESSING", name: "Đang xử lý" },
        { id: "FAIL", name: "Thanh toán thất bại" },
        { id: "PAID", name: "Đã thanh toán" },
        { id: "UNPAID", name: "Chưa thanh toán" },
        { id: "PARTIAL_PAID", name: "Thanh toán 1 phần" },
      ],

      showData: (row) => {
        if (row.paymentStatus === "PAID") {
          return `<span class="status status-success">${_this.$t(
            "common." + row.paymentStatus,
          )}</span>`
        }
        if (row.paymentStatus === "UNPAID") {
          return `<span class="status status-danger">${_this.$t(
            "common." + row.paymentStatus,
          )}</span>`
        }

        if (row.paymentStatus === "PARTIAL_PAID") {
          return `<span class="status status-warning">${_this.$t(
            "common." + row.paymentStatus,
          )}</span>`
        }
        if (row.paymentStatus === "FAIL") {
          return `<span class="status status-danger">Thanh toán thất bại </span>`
        }
        if (row.paymentStatus === "PENDING") {
          return `<span class="status status-warning">Chờ xác nhận</span>`
        }
      },
    },

    {
      title: "Trạng thái đơn",
      key: "orderStatus",
      searchKey: "orderStatus_ilike",
      noSort: true,

      searchType: "multi-select",
      minWidth: "100px",
      searchList: [
        { id: "FINISHED", name: "Đã hoàn thành" },
        { id: "PROCESSING", name: "Đang xử lý" },
        { id: "UNFINISHED", name: "Chưa hoàn thành" },
      ],
      showDataRaw: (r) => {
        if (r.orderStatus) {
          var out = ""
          var o = subStatuses.find((a) => a.code == r.subStatus)
          var sub = o ? o.name : r.subStatus
          sub = sub ? "(" + sub + ")" : ""
          if (r.isB2B) {
            sub = ""
          }
          if (r.orderStatus == "PROCESSING") {
            out += `Đang xử lý ${sub}`
          } else {
            out += `${_this.$t("bill_detail.status_" + r.orderStatus)}`
          }
          return out
        }
        return ""
      },
      showData: (r) => {
        var out = ""
        var o = subStatuses.find((a) => a.code == r.subStatus)
        var sub = o ? o.name : r.subStatus
        sub = sub ? "(" + sub + ")" : ""
        if (r.isB2B) {
          sub = ""
        }

        if (r.orderStatus == "FINISHED") {
          out += `<p class="status status-success">
          ${_this.$t("bill_detail.status_" + r.orderStatus)}
          <p>`
        }
        if (r.orderStatus == "UNFINISHED") {
          out += `<p class="status status-warning">
          ${_this.$t("bill_detail.status_" + r.orderStatus)}
          <p>`
        }
        if (r.orderStatus == "PROCESSING") {
          out += `<p class="status status-info">Đang xử lý ${sub}</p>`
        }

        if (r.orderStatus == "DELETED") {
          out += `<p class="status status-danger">
          ${_this.$t("bill_detail.status_" + r.orderStatus)}
          <p>`
        }

        if (r.orderStatus == "CANCEL") {
          out += `<p class="status status-danger">
          ${_this.$t("bill_detail.status_" + r.orderStatus)}
          <p>`
        }

        if (r.orderStatus == "FINISHED")
          return (
            out +
            `<p class="m-0 font-12">
          ${_this.$formatDate(r.invoiceDate)}
          |
          ${_this.$formatTime(r.invoiceDate)}
        </p>`
          )
        return out
      },
    },
    {
      title: "Khách hàng",
      searchKey: [
        "customers.phoneNumber_ilike",
        "customers.customerName_ilike",
        "customers.customerCode_ilike",
        "customers.shortCode_ilike",
      ],
      key: "customers.customerName",
      minWidth: "200px",
      showData: (r) =>
        `
        <label>${r.customers ? r.customers.customerCode : ""}</label>
        <p class="text-trim-2">${
          r.customers ? r.customers.customerName : ""
        }</p><p class="sub-text">${
          r.customers ? r.customers.phoneNumber : ""
        }</p>`,
      showDataRaw: (r) => (r.customers ? r.customers.customerName : ""),
    },
    {
      title: "Mã kế toán",
      key: "customers.shortCode",
      showDataRaw: (r) => (r.customers ? r.customers.shortCode : ""),
      hide: true,
      searchKey: "customers.shortCode_ilike",
    },

    {
      title: "SĐT Khách",
      key: "customers.phoneNumber",
      showDataRaw: (r) => (r.customers ? r.customers.phoneNumber : ""),
      nohide: true,
      searchKey: "customers.phoneNumber_ilike",
    },
    {
      title: "Mã Khách",
      key: "customers.customerCode",
      showDataRaw: (r) => (r.customers ? r.customers.customerCode : ""),
      hide: true,
      searchKey: "customers.customerCode_ilike",
    },
    _this.$permission("ADMIN:VIEW_COST_ORDER")
      ? {
          title: "Tổng giá vốn",
          key: "costTotal",
          className: "text-right",
          showData: (r) => {
            return _this.$formatMoney(r.costTotal, true)
          },
          searchType: "number",
          showDataRaw: (r) => r.costTotal,
        }
      : null,
    {
      title: "Tổng tiền",
      key: "total",
      className: "text-right",
      showData: (r) => {
        return _this.$formatCurrency(r.total, r.exchangeRate, r.currency)
        // return  _this.$formatMoney(r.beforeSaleOffTotal, true)
      },
      searchType: "number",
      showDataRaw: (r) => r.beforeSaleOffTotal,
    },
    {
      title: "CK / KM",
      key: "totalDiscount",
      className: "text-right",
      noSort: true,
      showData: (r) =>
        _this.$formatCurrency(r.totalDiscount, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.totalDiscount,
    },
    {
      title: "Phụ phí",
      key: "totalSurcharge",
      className: "text-right",
      showData: (r) =>
        _this.$formatCurrency(r.totalSurcharge, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.totalSurcharge,
    },
    {
      title: "Thuế",
      key: "taxMoney",
      className: "text-right",
      showData: (r) =>
        _this.$formatCurrency(r.taxMoney, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.taxMoney,
    },
    {
      title: "Tổng cộng",
      key: "grandTotal",
      className: "text-right",
      showData: (r) =>
        _this.$formatCurrency(r.grandTotal, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.grandTotal,
    },

    {
      title: "Đã thanh toán",
      key: "paidMoney",
      className: "text-right",
      noSort: true,
      showData: (r) =>
        _this.$formatCurrency(r.paidMoney, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.paidMoney,
    },

    {
      title: "Chưa thanh toán",
      key: "remainPayment",
      className: "text-right",
      showData: (r) =>
        _this.$formatCurrency(r.remainPayment, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.remainPayment,
    },
    {
      title: "Tiền Công nợ",
      key: "remainDebt",
      className: "text-right",
      showData: (r) =>
        _this.$formatCurrency(r.remainDebt, r.exchangeRate, r.currency),
      searchType: "number",
      showDataRaw: (r) => r.remainDebt,
    },

    {
      key: "description",
      width: "300px",
      searchKey: "description_ilike",
      title: "Ghi chú",
      showData: (row) => row.description,
    },
    {
      key: "invoiceProcessSteps",
      width: "300px",
      searchKey: [
        "invoiceProcessSteps.stepName_ilike",
        "invoiceProcessSteps.code_ilike",
        "invoiceProcessSteps.processDate_ilike",
      ],
      title: "Tiến trình",
      showData: (row) =>
        (row.invoiceProcessSteps || [])
          .map((a) => `${a.code} (${_this.$formatDate(a.processDate)})`)
          .join("<br />"),
    },

    {
      key: "invoiceCashPayments.paymentTime",
      width: "300px",
      searchType: "date-range",
      searchKey: [
        "invoiceCashPayments.paymentTime",
        "invoiceCardPayments.paymentTime",
      ],
      title: "Thanh toán",
      showData: (row) => {
        return (
          (row.invoiceCashPayments || [])
            .map(
              (a) =>
                `Tiền mặt: ${_this.$formatDate(
                  a.paymentTime,
                )}:  ---- ${_this.$formatCurrency(
                  a.totalPayment,
                  a.exchangePrice,
                  a.currencyUnit,
                )} `,
            )
            .join("<br />") +
          (row.invoiceCardPayments || [])
            .map(
              (a) =>
                `CK: ${_this.$formatDate(
                  a.paymentTime,
                )}: --------- ${_this.$formatCurrency(
                  a.totalPayment,
                  a.exchangePrice,
                  a.currencyUnit,
                )} `,
            )
            .join("<br />")
        )
      },
    },
    ...invoiceCustomFields,
    {
      key: "invoiceInitials.products",
      searchKey: [
        "invoiceInitials.products.name_ilike",
        "invoiceInitials.products.code_ilike",
      ],
      width: "300px",
      title: "Sẩn phẩm đặt hàng",
      showData: (r) =>
        r.invoiceInitials
          .slice(0, 3)
          .map(
            (a) =>
              `<p class="no-break m-0"><strong>${a.productQuantity} ${a.products.unit.name} ${a.products.code} </strong> | ${a.products.name}</p>`,
          )
          .join("") +
        (r.invoiceInitials.length > 3
          ? `<p>vả ${r.invoiceInitials.length - 3} sp khác</p>`
          : ""),
    },
  ].filter((a) => a)
  if (isRaw) {
    console.log(inputs)
    return inputs
  }
  console.log("inputs", inputs)
  return _this.$formatColumns(inputs, "Invoices")
}

export const getFieldIP = (_this) => {
  // const _this = Vue.prototype
  return [
    {
      key: "code",
      title: "Mã thanh toán",
      searchKey: "code_ilike",
      minWidth: "150px",
      showData: (r) => r.code,
    },
    {
      key: "type",
      title: "Loại thanh toán",
      searchType: "select",
      minWidth: "150px",
      searchList: [
        { id: "LetterOfCredit", name: "Thư tín dụng (L/C)" },
        { id: "AuthoritytoPurchase", name: "Ủy thác mua (A/P)" },
        { id: "Remittance", name: "Chuyển tiền" },
        { id: "Collection", name: "Thu hộ" },
        { id: "OpenAccount", name: "Mở tài khoản" },
        { id: "Guarantee", name: "Bảo lãnh" },
      ],

      showData: (r) => {
        if (r.type == "LetterOfCredit") {
          return `<span class="tag tag-info">Thư tín dụng (L/C)</span>`
        }
        if (r.type == "AuthoritytoPurchase") {
          return `<span class="sttagatus tag-warning">Ủy thác mua (A/P)</span>`
        }
        if (r.type == "Remittance") {
          return `<span class="tag tag-success">Chuyển tiền</span>`
        }
        if (r.type == "Collection") {
          return `<span class="tag tag-primary">Thu hộ</span>`
        }
        if (r.type == "OpenAccount") {
          return `<span class="tag tag-secondary">Mở tài khoản</span>`
        }
        if (r.type == "Guarantee") {
          return `<span class="tag tag-danger">Bảo lãnh</span>`
        }

        return r.type
      },
    },
    {
      key: "issueDate",
      title: "Ngày phát hành",
      searchType: "date-range",
      width: "120px",
      showData: (r) => _this.$formatDate(r.issueDate),
    },
    {
      key: "expiryDate",
      title: "Ngày hết hạn",
      searchType: "date-range",
      width: "120px",
      showData: (r) => _this.$formatDate(r.expiryDate),
    },
    {
      key: "amount",
      title: "Số tiền",
      className: "nobreak text-right",
      searchType: "number",
      // showData: (r) => _this.formatCurrency(r.amount),
    },
    {
      key: "status",
      title: "Trạng thái",
      searchType: "select",
      minWidth: "100px",
      searchList: [
        { id: "NEW", name: "Mới" },
        { id: "PAID", name: "Đã thanh toán" },
        { id: "CANCEL", name: "Chưa thanh toán" },
      ],
      showData: (r) => {
        if (r.status == "NEW") {
          return `<span class="status status-info">Mới</span>`
        }
        if (r.status == "PAID") {
          return `<span class="status status-success">Đã thanh toán</span>`
        }
        if (r.status == "PROCESSING") {
          return `<span class="status status-warning">Đang xử lý</span>`
        }
        if (r.status == "CANCEL") {
          return `<span class="status status-danger">Huỷ thanh toán</span>`
        }

        return r.status
      },
    },
    {
      key: "bankIssuer",
      title: "Ngân hàng phát hành",
      searchKey: "bankIssuer_ilike",
      minWidth: "200px",
    },
    {
      key: "bankAdvising",
      title: "Ngân hàng thông báo",
      searchKey: "bankAdvising_ilike",
      minWidth: "200px",
    },
    {
      key: "description",
      searchKey: "description_ilike",
      title: "Ghi chú",
      minWidth: "300px",
    },
    {
      key: "term",
      searchKey: "term_ilike",
      title: "Điều khoản thanh toán",
      minWidth: "300px",
    },
    ..._this.$customFieldsColumns("InternationalPayments"),
  ]
}
